import React from "react";
import droneImage from "../../assets/drone.webp";
import verificationImage from "../../assets/verification.webp";

const points = [
  "Contactability confirmed, so your team is not dialling dead numbers.",
  "Identity mismatches caught at submission, not at sanction.",
  "A bank account tied to the applicant from the first minute.",
  "A timestamped audit trail against every lead ID.",
];

function IntakeQuality() {
  return (
    <section className="overflow-hidden bg-[#191e1c] section-spacing">
      <div className="section-container">
        <div className="grid grid-cols-1 items-center gap-10 md:gap-14 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16 xl:gap-20">
          {/* ================= LEFT CONTENT ================= */}
          <div>
            {/* Label */}
            <p className="font-jakarta text-[11px] font-medium tracking-[0.34em] text-[var(--mint-green)] sm:text-[12px]">
              INTAKE QUALITY
            </p>

            {/* Heading */}
            <h2 className="mt-5 font-bricolage text-[28px] font-semibold leading-[1.15] tracking-[-0.8px] text-white sm:text-[34px] md:text-[38px] lg:text-[42px]">
              Verification cuts the risk before it reaches you.
            </h2>

            {/* Bullet Points */}
            <ul className="mt-7 space-y-3.5 sm:mt-8 sm:space-y-4">
              {points.map((text) => (
                <li
                  key={text}
                  className="flex items-start gap-3 font-jakarta text-[14px] leading-[1.6] text-[#9fa9a5] sm:text-[15px]"
                >
                  <span
                    aria-hidden="true"
                    className="mt-[1px] shrink-0 font-bold text-[var(--mint-green)]"
                  >
                    ✓
                  </span>
                  <span>{text}</span>
                </li>
              ))}
            </ul>

            {/* Badge */}
            <div className="mt-8 flex items-center gap-3 sm:mt-10 sm:gap-3.5">
              <img
                src={verificationImage}
                alt=""
                className="h-auto w-[28px] object-contain sm:w-[32px]"
                loading="lazy"
                decoding="async"
              />
              <span className="font-jakarta text-[12px] font-semibold tracking-[0.06em] text-[var(--mint-green)] sm:text-[13px]">
                Avg. verification time 4.2 min
              </span>
            </div>
          </div>

          {/* ================= RIGHT 3D IMAGE ================= */}
          <div className="flex items-center justify-center lg:justify-end">
            <img
              src={droneImage}
              alt="Bank network connection hub"
              className="h-auto w-[260px] object-contain transition-transform duration-300 hover:scale-105 sm:w-[320px] md:w-[360px] lg:w-[410px]"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default IntakeQuality;
